module.exports = __webpack_public_path__ + "img/Monte_Kope_107.8503bf94.jpg";